import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PopupTitle from '../common/popup_title';
import MyDayContentCard from './my_day_content_card';
import { useGetSharedProgrammeQuery } from '../../app/smorgAppSyncGraphQLApi';
import {
  getContentEntriesForCalendarDay,
  programmeStartCalendarDay,
} from '../../services/my_day';
import { calendarDayFromJSDate } from '../../services/dates';
import { useCurrentProgrammeEnrollmentQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { SHARED_PROGRAMMES_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';

const MyDayTodaysLessonsView = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const todayOverride = searchParams.get('asOf');

  const today = todayOverride || calendarDayFromJSDate(new Date());

  const { data: currentProgrammeEnrollment } =
    useCurrentProgrammeEnrollmentQuery();

  const programmeStartDay = programmeStartCalendarDay(
    currentProgrammeEnrollment,
  );

  const { sharedProgrammeID } = currentProgrammeEnrollment || {};

  const { data: sharedProgramme } = useGetSharedProgrammeQuery(
    sharedProgrammeID,
    {
      skip: !sharedProgrammeID,
      refetchOnMountOrArgChange: SHARED_PROGRAMMES_REFRESH_INTERVAL_SECONDS,
    },
  );

  const todaysProgrammeEntriesOfTypeContentFromSharedProgramme =
    programmeStartDay &&
    sharedProgramme &&
    getContentEntriesForCalendarDay(sharedProgramme, programmeStartDay, today);

  const onClickBack = () => navigate(-1);

  return (
    <div className="my-day-view">
      <div className="topNavBarMobile" style={{ flexDirection: 'column' }}>
        <PopupTitle
          titleText="Today's Lessons"
          backButtonEnabled
          onClickBack={onClickBack}
        />
      </div>
      {todaysProgrammeEntriesOfTypeContentFromSharedProgramme.map(
        (programmeEntry) => (
          <div key={programmeEntry.objectID} style={{ flexShrink: 0 }}>
            <MyDayContentCard
              contentEntryID={programmeEntry.objectID}
              parentID={sharedProgrammeID}
            />
          </div>
        ),
      )}
    </div>
  );
};

export default MyDayTodaysLessonsView;
